export var RelationshipAction;
(function (RelationshipAction) {
    RelationshipAction["follow"] = "FOLLOW";
    RelationshipAction["unfollow"] = "UNFOLLOW";
    RelationshipAction["block"] = "BLOCK";
    RelationshipAction["unblock"] = "UNBLOCK";
    RelationshipAction["approve"] = "APPROVE";
    RelationshipAction["ignore"] = "IGNORE";
})(RelationshipAction || (RelationshipAction = {}));
